import { actionCreator, ActionReturnType, Loading, loadingNotStarted, loadingIsLoading, loadingFinished } from "@itk/typescript-utils";

export enum Action {
  InitFileDownloadInstance = "@@ITK:SRC:HOOKS:FILE-DOWNLOAD:FILE-DOWNLOAD-STORE.TS:ACTION:INITFILEDOWNLOADINSTANCE",
  GetFileDownloadRequest = "@@ITK:SRC:HOOKS:FILE-DOWNLOAD:FILE-DOWNLOAD-STORE.TS:ACTION:GETFILEDOWNLOADREQUEST",
  GetFileDownloadSuccess = "@@ITK:SRC:HOOKS:FILE-DOWNLOAD:FILE-DOWNLOAD-STORE.TS:ACTION:GETFILEDOWNLOADSUCCESS",

  ResetFileDownload = "@@ITK:SRC:HOOKS:FILE-DOWNLOAD:FILE-DOWNLOAD-STORE.TS:ACTION:RESETFILEDOWNLOAD"
}

type FileDownloadInstance = {
  instanceId: string;
  loading: Loading<{ url: string; fileName: string; originalExtension: string }>;
};

type FileDownloadState = {
  instances: FileDownloadInstance[];
};

const initialState: FileDownloadState = {
  instances: []
};

export const fileDownloadActions = {
  initFileDownloadInstance: (instanceId: string) => actionCreator(Action.InitFileDownloadInstance, { instanceId }),
  getFileDownloadRequest: (instanceId: string, fileId: string, preview = false) => actionCreator(Action.GetFileDownloadRequest, { instanceId, fileId, preview }),
  getFileDownloadSuccess: (instanceId: string, data: { url: string; fileName: string; originalExtension: string }) => actionCreator(Action.GetFileDownloadSuccess, { instanceId, data }),

  resetFileDownload: (instanceId: string) => actionCreator(Action.ResetFileDownload, { instanceId })
};

export const reducer = (state = initialState, action: ActionReturnType<typeof fileDownloadActions>): FileDownloadState => {
  switch (action.type) {
    case Action.InitFileDownloadInstance:
      if (state.instances.some(i => i.instanceId === action.payload.instanceId)) return state;
      return { ...state, instances: [...state.instances, { instanceId: action.payload.instanceId, loading: loadingNotStarted }] };
    case Action.GetFileDownloadRequest:
      return { ...state, instances: state.instances.map(i => (i.instanceId !== action.payload.instanceId ? i : { ...i, loading: loadingIsLoading })) };
    case Action.GetFileDownloadSuccess:
      return { ...state, instances: state.instances.map(i => (i.instanceId !== action.payload.instanceId ? i : { ...i, loading: loadingFinished(action.payload.data) })) };

    case Action.ResetFileDownload:
      return { ...state, instances: state.instances.map(i => (i.instanceId !== action.payload.instanceId ? i : { ...i, loading: loadingNotStarted })) };
    default:
      return state;
  }
};
